/** Integer movement and heading helpers. Angles run clockwise from north. */
import { SCALED_SINES, ANGLE_GRID } from './tables.js';
export function wrapDeg(a: number): number {
  if (a < 0) return 360 + a;
  if (a > 359) return a - 360;
  return a;
}
export function scaledSin(a: number): number {
  if (a < 90) return SCALED_SINES[a]!;
  if (a === 90) return 128;
  if (a < 180) return SCALED_SINES[180 - a]!;
  if (a === 180) return 0;
  if (a < 270) return -SCALED_SINES[a - 180]!;
  if (a === 270) return -128;
  if (a < 360) return -SCALED_SINES[360 - a]!;
  return 1;
}
export function scaledCos(a: number): number {
  return scaledSin(wrapDeg(a + 90));
}
export function turnDir(from: number, to: number): number {
  if (Math.abs(from - to) <= 22) return 0;
  if (to >= from) {
    const direct = to - from;
    const around = 360 - to + from;
    return direct <= around ? 3 : 2;
  }
  const direct = from - to;
  const around = 360 - from + to;
  return direct <= around ? 2 : 3;
}
export function angleTo(x1: number, y1: number, x2: number, y2: number): number {
  let dxRight = 1;
  let dyDown = 1;
  let dx = x1 - x2;
  let dy = y1 - y2;
  if (dy < 0) dyDown = 0;
  if (dx < 0) dxRight = 0;
  if (dx === 0) return dy < 0 ? 180 : 0;
  if (dy === 0) return dx < 0 ? 90 : 270;
  dx = Math.abs(dx);
  dy = Math.abs(dy);
  const sum = dx + dy;
  const r = ((dx * 10) / sum) | 0;
  const c = ((dy * 10) / sum) | 0;
  if (dxRight === 0 && dyDown === 1) return ANGLE_GRID[r]![c]!;
  if (dxRight === 0 && dyDown === 0) return 90 + ANGLE_GRID[c]![r]!;
  if (dxRight === 1 && dyDown === 0) return 180 + ANGLE_GRID[r]![c]!;
  if (dxRight === 1 && dyDown === 1) return 270 + ANGLE_GRID[c]![r]!;
  return -1;
}
export function moveDelta(sinCos: number): number {
  return (sinCos * 10) >> 7;
}
